const normalizeStatusValue = (value) => {
    return typeof value === 'string' ? value.toLowerCase() : null;
};

export const getClientStatementStatus = (transaction) => {
    return {
        kind: 'client',
        state: normalizeStatusValue(transaction?.ClientInvoiceStatus),
        clientId: transaction?.ClientID ?? null,
        invoiceId: transaction?.InvoiceID ?? null,
        invoiceNumber: transaction?.InvoiceNumber ?? null,
        invoiceDate: transaction?.InvoiceDate ?? null,
        invoicePosted: Boolean(transaction?.InvoicePosted),
        raw: transaction,
    };
};

export const getSubjectStatementStatus = (statement) => {
    return {
        kind: 'subject',
        state: normalizeStatusValue(statement?.Status),
        paidState: normalizeStatusValue(statement?.PaidStatus),
        paidStatusName: statement?.PaidStatusName ?? null,
        invoiceId: statement?.InvoiceID ?? null,
        invoiceNumber: statement?.InvoiceNumber ?? null,
        invoiceDate: statement?.InvoiceDate ?? null,
        invoicePosted: Boolean(statement?.InvoicePosted),
        paymentId: statement?.PaymentID ?? null,
        paymentNumber: statement?.PaymentNumber ?? null,
        paymentDate: statement?.PaymentDate ?? null,
        raw: statement,
    };
};

export const getPayableSubjectStatementStatus = (transaction) => {
    const statements = transaction?.Statements || [];
    const invoiceStatement = statements.find((statement) => statement.InvoiceID) || null;
    const paidStatement = statements.find((statement) => statement.PaidStatus === 'Paid') || null;

    // IDs of the Nw3Payment objects containing the paid row (may be more than one)
    const nw3PaymentIds = Array.isArray(paidStatement?.IsInNw3PaymentIDs) ? paidStatement.IsInNw3PaymentIDs : [];

    let paymentSource = null;
    if (paidStatement) {
        if (paidStatement.IsInNw3Payment || paidStatement.Nw3PaymentID || nw3PaymentIds.length) {
            paymentSource = 'nw3';
        } else if (paidStatement.PaymentID) {
            paymentSource = 'native';
        } else {
            paymentSource = 'legacy';
        }
    }

    let state = null;
    if (paidStatement) {
        state = 'paid';
    } else if (invoiceStatement) {
        if (invoiceStatement.InvoicePosted) {
            state = 'posted';
        } else if (invoiceStatement.InvoiceNumber) {
            state = 'invoiced';
        } else {
            state = 'locked';
        }
    }

    return {
        kind: 'payable-subject',
        isPaymentRow: Boolean(transaction?.isPayment),
        state,
        invoiced: Boolean(invoiceStatement),
        invoicePosted: statements.some((statement) => Boolean(statement.InvoicePosted)),
        invoiceId: invoiceStatement?.InvoiceID ?? null,
        invoiceNumber: invoiceStatement?.InvoiceNumber ?? null,
        invoiceDate: invoiceStatement?.InvoiceDate ?? null,
        paid: Boolean(paidStatement),
        paymentId: paidStatement?.PaymentID ?? null,
        nw3PaymentId: paidStatement?.Nw3PaymentID ?? null,
        nw3PaymentIds,
        paymentNumber: paidStatement?.PaymentNumber ?? null,
        paymentDate: paidStatement?.PaymentDate ?? null,
        paymentSource,
        raw: transaction,
    };
};
